import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import { Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomTable from "../../../components/CustomTable";
import CustomTextField from "../../../components/CustomTextField";
import {
  deleteTreatmentPlanById,
  getTreatmentPlans,
} from "../../../redux/reducers/planSlice";
import { AppColors } from "../../../util/AppColors";
import { delBtn, eyeBtn } from "../../../util/CommonIconStyle";
import TreatmentPlanCreate from "./TreatmentPlanCreate";

const tableHeader = [
  "planName",
  "species",
  "createdBy",
  "lastUpdated",
  "extraStatus",
];

const TreatmentPlan = () => {
  const dispatch = useDispatch();
  const fetchRef = useRef(false);
  const [createVsble, setCreateVsble] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [delModVsble, setDelModVsble] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const { treatmentPlans } = useSelector((state) => state?.plan);

  useEffect(() => {
    if (fetchRef.current) return;
    fetchRef.current = true;
    onApiCall();
  }, [dispatch]);

  const onApiCall = (url = "") => {
    dispatch(getTreatmentPlans(url));
  };

  const handleDelete = (det) => {
    setSelectedPlan(det);
    setDelModVsble(true);
  };

  const handleEdit = (det) => {
    setSelectedPlan(det);
    setCreateVsble(true);
  };

  const handleCloseDel = () => {
    setSelectedPlan(null);
    setDelModVsble(false);
  };

  const handleConfirmDel = () => {
    dispatch(deleteTreatmentPlanById(selectedPlan?.planId)).then((res) => {
      if (res?.payload) {
        onApiCall();
        handleCloseDel();
      }
    });
  };

  const getTableList = () => {
    return treatmentPlans?.map((pln) => ({
      planName: pln?.planName,
      species: pln?.species?.join(", "),
      createdBy: pln?.clinicId,
      lastUpdated: moment().format("DD MMM YYYY"),
      extraStatus: (
        <div className="flex-row">
          <div className="cursor" onClick={() => handleDelete(pln)}>
            <div className="flex-center">
              <DeleteOutlineIcon sx={delBtn} />
            </div>
            <Typography className="red3 fs8 txt-semi-bold text-align-center">
              Delete
            </Typography>
          </div>
          <div className="cursor ml10" onClick={() => handleEdit(pln)}>
            <div className="flex-center">
              <EditIcon sx={eyeBtn} />
            </div>
            <Typography className="blue-color fs8 txt-semi-bold text-align-center">
              Edit
            </Typography>
          </div>
        </div>
      ),
    }));
  };

  const handleCreate = () => {
    setSelectedPlan(null);
    setCreateVsble(true);
  };

  return (
    <>
      {createVsble ? (
        <TreatmentPlanCreate
          setCreateVsble={setCreateVsble}
          selectedPlan={selectedPlan}
          setSelectedPlan={setSelectedPlan}
        />
      ) : null}
      {!createVsble && (
        <div>
          <div className="flex-row-ali-cen flex-center mt5">
            <div className="w30Per">
              <CustomTextField
                placeholder="Search"
                name="name"
                fullWidth
                handleChange={(e) => setSearchValue(e?.target?.value)}
                value={searchValue}
                backgroundColor={AppColors.lightBlue2}
              />
            </div>
            <div className="ml20">
              <CustomButton text="Create" onClick={handleCreate} smallBtn />
            </div>
          </div>

          <CustomTable
            columns={tableHeader}
            datas={getTableList()}
            grey
            maxHeight="70vh"
          />
        </div>
      )}

      <CustomModal
        open={delModVsble}
        onClose={handleCloseDel}
        header="Delete"
        modal
        modalWidth={30}
      >
        <div className="ml10">Are you sure want to delete the plan?</div>
        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton text="Cancel" onClick={handleCloseDel} smallBtn />
          </div>
          <div className="ml20">
            <CustomButton
              redBtn
              text="Confirm"
              onClick={handleConfirmDel}
              smallBtn
            />
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default TreatmentPlan;
